import { differenceInCalendarMonths, isAfter } from 'date-fns';

const QUEBEC_PROVINCE_CODE = 'QC';
const CPP_QPP_MINIMUM_CONTRIBUTION_AGE = 18;
const CPP_MAXIMUM_CONTRIBUTION_AGE = 70;
const QPP_MAXIMUM_CONTRIBUTION_AGE = 72;

/**
 * CPP/QPP contributions start the month after an employee turns 18. Outside Quebec, CPP
 * contributions stop the month after an employee turns 70. In Quebec, QPP contributions stop
 * at the end of January of the year following the year an employee turns 72.
 */
export function isBornOnOutsideCppQppRange(
    bornOn: Date | string | null | undefined,
    province: string | null | undefined,
    referenceDate: Date = new Date()
): boolean {
    if (!bornOn) {
        return false;
    }

    const bornOnDate = bornOn instanceof Date ? bornOn : new Date(bornOn);

    const ageInMonths = differenceInCalendarMonths(referenceDate, bornOnDate);

    if (ageInMonths < CPP_QPP_MINIMUM_CONTRIBUTION_AGE * 12 + 1) {
        return true;
    }

    if (province === QUEBEC_PROVINCE_CODE) {
        const endOfEligibleJanuary = new Date(bornOnDate.getFullYear() + QPP_MAXIMUM_CONTRIBUTION_AGE + 1, 0, 31);
        return isAfter(referenceDate, endOfEligibleJanuary);
    }

    return ageInMonths > CPP_MAXIMUM_CONTRIBUTION_AGE * 12 + 1;
}
